import { apiRest } from "./constants";
import { decodeToken, encodeToken } from "./utils";
import axios from "axios";

// DEFAULT AXIOS CONFIGURATION
axios.defaults.withCredentials = true;
axios.defaults.baseURL = apiRest;

// Métodos HTTP a funciones de axios
const methods = {
  get: axios.get,
  post: axios.post,
  patch: axios.patch,
  delete: axios.delete,
  put: axios.put,
};

// Función recursiva para manejar objetos anidados
export function appendFormData(formData, key, value) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    // Si es un objeto, convertirlo a JSON
    formData.append(key, JSON.stringify(value));
  } else if (Array.isArray(value)) {
    // Si es un arreglo, recorrer sus elementos
    value.forEach((item, index) => {
      formData.append(`${key}[${index}]`, JSON.stringify(item));
    });
  } else if (value !== null && value !== undefined) {
    // Para valores primitivos o no nulos/indefinidos
    formData.append(key, value);
  }
}

export const apiBasic = async (data, path, method = "post") => {
  console.log("apiBasic");
  console.log(data);
  try {
    let payload;
    let headers = {};

    if (data?.files) {
      headers["Content-Type"] = "multipart/form-data";
      const dataForm = new FormData();

      // Recorrer el objeto principal
      for (const [key, value] of Object.entries(data)) {
        appendFormData(dataForm, key, value);
      }

      // Recorrer imágenes
      data.files.length > 0 ? data.files.forEach((image) => dataForm.append("files", image)) : dataForm.append("files", data.files);

      dataForm.forEach((value, key) => {
        console.log(`${key}:`, value);
      });
      payload = dataForm;
    } else {
      payload = data;
    }

    // If delete metod
    if (method === "delete") payload = { data: data };

    // Selección del método basado en la entrada o fallback a POST
    const httpMethod = methods[method] || axios.post;
    // Ejecución de la solicitud
    const response = await httpMethod(apiRest + path, payload);
    return response.data;
  } catch (error) {
    console.error(`🚀 ~ apiBasic ${path} ~ error:`, error);
    return error.response.data;
    //throw error; // Rethrow para manejarlo en un nivel superior si es necesario
  }
};

export const apiToken = async (data, path, method = "post") => {
  try {
    const token = encodeToken(data);
    let payload;
    let headers = {};

    if (data?.files) {
      headers["Content-Type"] = "multipart/form-data";
      const dataForm = new FormData();

      // Recorrer el objeto principal
      for (const [key, value] of Object.entries(data)) {
        appendFormData(dataForm, key, value);
      }

      // Recorrer imágenes
      data.files.forEach((image) => dataForm.append("files", image));

      dataForm.forEach((value, key) => {
        console.log(`${key}:`, value);
      });
      payload = dataForm;
    } else {
      payload = { token };
    }

    // If delete metod
    if (method === "delete") payload = { data: data };

    const httpMethod = methods[method] || axios.post;
    const response = await httpMethod(apiRest + path, payload, { headers });
    console.log("RESPONSE ANTESDE DECODE: ", response);
    // Decode
    return { ...response.data, data: decodeToken(response.data) };
  } catch (error) {
    console.log("🚀 ~ apiToken " + path + " ~ error:", error);
    return error.response.data;
  }
};

export const apiTokenNotDecode = async (data, path) => {
  try {
    // CODIFICAMOS NUESTRO ENVÍO DE DATOS
    const token = encodeToken(data);

    const response = await axios.post(apiRest + path, {
      token,
    });

    return response;
  } catch (error) {
    console.log("🚀 ~ apiToken " + path + " ~ error:", error);
    return error.response.data;
  }
};

export const apiGet = async (path, params = "") => {
  try {
    const response = await axios.get(path, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.log("🚀 ~ apiGet " + path + " ~ error:", error);
    return error.response.data;
  }
};

export const logout = async () => {
  const baseApi = apiRest.replace(/^(https?:\/\/[^/]+).*$/, "$1");
  try {
    let payload;
    // Selección del método
    const httpMethod = methods["delete"];
    // Ejecución de la solicitud
    const response = await httpMethod(baseApi + "/logout", payload);
    return response.data;
  } catch (error) {
    console.error(`🚀 ~ apiBasic "/logout" ~ error:`, error);
    return error.response.data;
  }
};

export const getCorporationInfo = async () => {
  const baseApi = apiRest.replace(/^(https?:\/\/[^/]+).*$/, "$1");
  try {
    let payload;
    // Selección del método
    const httpMethod = methods["get"];
    // Ejecución de la solicitud
    const response = await httpMethod(baseApi + "/get-corporation-info", payload);
    return response.data;
  } catch (error) {
    console.error(`🚀 ~ apiBasic "/logout" ~ error:`, error);
    return error.response.data;
  }
};
